import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterDepositReports from 'views/customers/reports/deposit_report/filterDepositReports'; // Importing filter for deposit reports
import TableDepositReport from 'views/customers/reports/deposit_report/tableDepositReports'; // Importing table for deposit reports
import DetailsDepositReport from 'views/customers/reports/deposit_report/detailsDepositReports'; // Importing details view for deposit reports
import RecordDepositReport from 'views/customers/reports/deposit_report/recordDepositReports'; // Importing record view for deposit reports
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the deposit report view.
 * @extends JetView
 */
export default class depositReportView extends JetView {
    /**
     * Configures the layout of the deposit report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Right panel configuration
        const right = {
            type: 'wide',
            minWidth: 200,
            rows: [RecordDepositReport], // Contains the record deposit report component
        };

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetching
                },
            ],
        };

        // Left panel configuration
        const left = {
            height: screen.width < 500 ? 500 : 0, // Responsive height based on screen width
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply the current theme
                    elements: [
                        {
                            view: 'label',
                            label: _('Reporte de Depósitos'), // Localized label for the report
                            width: 300,
                        },
                    ],
                },
                FilterDepositReports, // Filter component for deposit reports
                TableDepositReport, // Table component for displaying deposit reports
                toolbar, // Toolbar component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Main layout configuration
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean layout type
            view: 'form', // Form view type
            rows: [
                {
                    responsive: 'a5', // Responsive layout
                    type: 'wide',
                    cols: [left, right], // Columns containing left and right panels
                },
            ],
        };
    }
}

// FILE DOCUMENTED
